import Flow from "../common/Flow";
import Typography from "../common/Typography";
import Table from "../common/Table";

function SystemDetail({ store }) {
  const system = store.state.system;

  return (
    <Flow $space={3}>
      <Typography as="h2" fontSize="xl">{system.symbol}</Typography>
      <Table>
        <tbody>
          <tr>
            <th>Waypoints</th>
            <td>{system.waypoints.length}</td>
          </tr>
          <tr>
            <th>Type</th>
            <td>{system.type}</td>
          </tr>
        </tbody>
      </Table>
    </Flow>
  );
}

export default SystemDetail;
